import React from 'react';

import { WorkListingItem } from '$partials/items';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$root/types/components/partials/modules.d.ts').WorkGridBlock}
 */
const WorkGrid = ({
    displayTitle,
    layout,
    works,
}) => {
    if (!works?.length) { return null; }
    if (layout === 'full_width') {
        return (
            <div className='w-full'>
                {works.map((itm, idx) => {
                    return (
                        <div key={itm?.work.id}>
                            <WorkListingItem
                                displayTitle={displayTitle}
                                {...itm.work}/>
                        </div>
                    );
                })}
            </div>
        );
    }


    return (
        <>
            {/* Desktop */}
            <div className='hidden sm:flex w-full'>
                <div className={layout === 'large_left' ? 'w-4/7' : 'w-3/7'}>
                    {works.map((itm, idx) => {
                        if (layout === 'large_left' && idx === works.length - 1 ) {
                            return null;
                        }
                        if (layout === 'large_right' && idx % 2 === 0) {
                            return (
                                <div key={itm?.work.id}>
                                    <WorkListingItem
                                        displayTitle={displayTitle}
                                        {...itm.work}/>
                                </div>
                            );
                        }
                        if (idx % 2 === 0) {
                            return (
                                <div key={itm?.work.id}>
                                    <WorkListingItem
                                        displayTitle={displayTitle}
                                        {...itm.work}/>
                                </div>
                            );
                        }
                    })}
                </div>
                <div className={layout === 'large_right' ? 'w-4/7' : 'w-3/7'}>
                    {works.map((itm, idx) => {
                        if (layout === 'large_left' && idx === works.length - 1 ) {
                            return (
                                <div key={itm?.work.id}>
                                    <WorkListingItem
                                        displayTitle={displayTitle}
                                        {...itm.work}/>
                                </div>
                            );
                        }

                        if (idx % 2 !== 0) {
                            return (
                                <div key={itm?.work.id}>
                                    <WorkListingItem
                                        displayTitle={displayTitle}
                                        {...itm.work}/>
                                </div>
                            );
                        }
                    })}
                </div>
            </div>
            {/* Mobile */}
            <div className='w-full sm:hidden'>
                {works.map((itm, idx) => {
                    return (
                        <div key={itm?.work.id}>
                            <WorkListingItem
                                displayTitle={displayTitle}
                                {...itm.work}/>
                        </div>
                    );
                })}
            </div>
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default WorkGrid;
